import ReportMutationTypes from './ReportTemplateMutationTypes';

const ReportTemplateMutations = {
  [ReportMutationTypes.UPDATE_TEMPLATES](state, templates) {
    state.templates = templates;
  },
};

export default ReportTemplateMutations;
